import Cookie from "react-cookies";

export const KEY = {
  ACCESS_TOKEN: "access_token",
  MBF_ACCESS_TOKEN: "mbf_access_token",
  ANONYMOUS_TOKEN: "anonymous_token",
};

export const load = (key) => {
  return Cookie.load(key);
};

export const save = (key, value, option) => {
  const timeNow = new Date();
  timeNow.setFullYear(timeNow.getFullYear() + 1);
  Cookie.save(key, value, option);
};

export const remove = (key) => {
  const timeNow = new Date();
  timeNow.setFullYear(timeNow.getFullYear() + 1);
  Cookie.remove(key);
};
